import {
  create_project_set,
  update_project_set,
  delete_project_set,
  recover_project_set,
  query_project_set_list,
  get_project_set_item_detail,
  get_set_record_item_detail,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-projectset-config';

import { reactive } from 'vue';
import double_table_info_modal from '@/components/info-modal/double_table_info_modal';
import {get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '套餐编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写套餐编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '套餐名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写套餐名称',
    },
    {
      type: 'remoteselect',
      name: 'project_type_id',
      label: '项目分类',
      disabled: false,
      placeholder: '请选择项目分类',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-projecttype',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    code: null,
    project_type_id: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '禁用' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 9,
    },
    wrapperCol: {
      span: 15,
    },
  },
  fields: [],
  rules: {
    name: [{ required: true, message: '请填输入套餐名称' }],
    project_type_id: [{ required: true, message: '请填输入项目分类' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    price: null,
    project_type_id: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    price: null,
    project_type_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '套餐管理',
  addModalTitle: '新建套餐',
  updateTitle: '修改套餐',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    project_id: 'id',
  },
  delete: {
    project_id: 'id',
  },
  recover: {
    project_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    project_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    width: 50,
    dataIndex: 'index',
  },
  {
    title: '套餐编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '套餐名称',
    dataIndex: 'name',
    checked: true,

    cellComponent: 'click',
    cb: (record: any) => {
      get_project_set_item_detail({ org_id: current_org?.id, project_set_id: record.id }).then(
        (res: any) => {
          const card: any[] = [
            { title: '序号', dataIndex: 'index', width: 100 },
            { title: '卡编号', dataIndex: 'code', width: 200 },
            { title: '卡名称', dataIndex: 'name', width: 200 },
            { title: '项目价格', dataIndex: 'price', width: 150 },
            { title: '项目次数', dataIndex: 'project_set_num', width: 150 },
          ];
          const project: any[] = [
            { title: '序号', dataIndex: 'index', width: 100 },
            { title: '项目编号', dataIndex: 'code', width: 200 },
            { title: '项目名称', dataIndex: 'name', width: 200 },
            { title: '项目价格', dataIndex: 'price', width: 150 },
            { title: '项目次数', dataIndex: 'project_set_num', width: 150 },
          ];

          double_table_info_modal(
            record.project_set__name,
            '卡信息',
            card,
            res.card_item,
            '单信息',
            project,
            res.item,
          );
        },
      );
    },
  },
  {
    title: '套餐价格',
    dataIndex: 'price',
    checked: true,
  },
  {
    title: '项目分类',
    dataIndex: 'project_type__name',
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push(
  { type: 'custom', slotName: 'is_active', field_true: '可用', field_false: '禁用' },
  {
    type: 'click',
    slotName: 'project_name',
    cb: (record: any) => {
      get_project_set_item_detail({ org_id: current_org?.id, project_set_id: record.id }).then(
        (res: any) => {
          const card: any[] = [
            { title: '序号', dataIndex: 'index', width: 100 },
            { title: '卡编号', dataIndex: 'code', width: 200 },
            { title: '卡名称', dataIndex: 'name', width: 200 },
            { title: '项目价格', dataIndex: 'price', width: 150 },
            { title: '项目次数', dataIndex: 'project_set_num', width: 150 },
          ];
          const project: any[] = [
            { title: '序号', dataIndex: 'index', width: 100 },
            { title: '项目编号', dataIndex: 'code', width: 200 },
            { title: '项目名称', dataIndex: 'name', width: 200 },
            { title: '项目价格', dataIndex: 'price', width: 150 },
            { title: '项目次数', dataIndex: 'project_set_num', width: 150 },
          ];
          double_table_info_modal(
            '套餐信息',
            '卡信息',
            card,
            res.card_item,
            '单信息',
            project,
            res.item,
          );
        },
      );
    },
  },
);
export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_project_set_list,
    addData: create_project_set,
    updateData: update_project_set,
    removeData: delete_project_set,
    recoverData: recover_project_set,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
